import React from 'react'
import PropTypes from 'prop-types'

import MuiDialog from '@mui/material/Dialog'
import Grid from '@mui/material/Grid2'

import Button from '@mui/material/Button'

const LoggedOutModal = ({ handleClose, open }) => (
  <MuiDialog
    disableBackdropClick
    disableEscapeKeyDown
    disablePortal
    fullWidth
    open={open}
    scroll="body"
  >
    <Grid container justifyContent="center">
      You have been logged out!
    </Grid>
    <Grid container justifyContent="center">
      <Button
        onClick={handleClose}
      >
        Ok
      </Button>
    </Grid>
  </MuiDialog>
)

LoggedOutModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
}

export default LoggedOutModal
